export default __webpack_public_path__ + "static/media/KR_Text_World5.bd54c428.svg";